import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getBinTypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: guid
        description: name
      }
      recordCount
    }
  }
`;

function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectBinType = ({
  label = 'Τύπος Κάδου',
  name = 'binTypeGuid',
  defaultValues = {},
  size = 'sm',
  ...rest
}: LcFsProps) => {
  const where = JSON.stringify({ isNotActive: 0 });
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetValues}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};

